import React from 'react';
import {
  AlertDialog,
  AlertDialogAction,
  AlertDialogCancel,
  AlertDialogContent,
  AlertDialogDescription,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogTitle,
} from './ui/alert-dialog';

/**
 * NavigationBlockerDialog — Affiche une confirmation quand useNavigationGuard bloque la navigation.
 * 
 * @param {{ blocker: import('react-router-dom').Blocker }} props
 */
const NavigationBlockerDialog = ({ blocker }) => {
  if (!blocker || blocker.state !== 'blocked') return null;

  return (
    <AlertDialog open={true} onOpenChange={() => {}}>
      <AlertDialogContent data-testid="navigation-blocker-dialog">
        <AlertDialogHeader>
          <AlertDialogTitle>Quitter sans enregistrer ?</AlertDialogTitle>
          <AlertDialogDescription>
            Vous avez des modifications non enregistrées. Si vous quittez cette page, elles seront perdues.
          </AlertDialogDescription>
        </AlertDialogHeader>
        <AlertDialogFooter>
          <AlertDialogCancel onClick={() => blocker.reset()} data-testid="navigation-blocker-stay">
            Rester sur la page
          </AlertDialogCancel>
          <AlertDialogAction
            onClick={() => blocker.proceed()}
            className="bg-destructive text-destructive-foreground hover:bg-destructive/90"
            data-testid="navigation-blocker-leave"
          >
            Quitter sans enregistrer
          </AlertDialogAction>
        </AlertDialogFooter>
      </AlertDialogContent>
    </AlertDialog>
  );
};

export default NavigationBlockerDialog;
